import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import pattern from '../assets/images/pattern.png';

import Header from '../layout/partials/Header';
import Button from '../components/Button';

const Modal = ({ isModalOpen, closeModal, setIsChecked }) => {
  const { i18n, t } = useTranslation();

  return (
    <>
      {isModalOpen
        ? createPortal(
            <div className="bg-brandPrimary w-[100vw] h-[100vh] absolute top-0 left-0 z-30">
              <img src={pattern} alt="pattern" className="lg:w-full w-[60%] absolute bottom-0 left-0 z-[-1]" />

              <Header />

              <div className="_gradient-border w-[80%] lg:h-[69%] h-[60%] px-10 py-10 sm:mt-20 mt-8 rounded-[6px] relative left-[50%] translate-x-[-50%] overflow-y-scroll z-40">
                <h1 className="md:text-4xl lg:text-6xl text-2xl text-brandAccent text-center lg:mt-12 mt-2">
                  {t('termsAndConditions')}
                </h1>
                <section className="lg:text-4xl md:mx-8 my-12">
                  {i18n.language === 'en' ? (
                    <div>
                      <p className="mb-6">
                        By providing your name, you consent to Health Canada and Proof Experiences using this
                        information to email you, should you be the winner of the prize draw for a{' '}
                        <span className="font-bold">$5 coffee gift card (or equivalent prize)</span>.
                      </p>
                      <p className="mb-6">
                        This information will not be used for sales or marketing solicitation or shared with any
                        third-party entity.
                      </p>
                      <p className="mb-6">We will not retain any personal data once the game is over.</p>
                      <p className="mb-6">
                        No purchase necessary. Open to age of majority residents of Canada. Contest opens{' '}
                        <span className="font-bold">
                          September 20<sup>th</sup>, 2026 at 9 AM
                        </span>{' '}
                        and closes{' '}
                        <span className="font-bold">
                          November 30<sup>th</sup>, 2026 at 5 PM
                        </span>
                        . <span className="font-bold">50 PRIZES</span> are available each day consisting of a{' '}
                        <span className="font-bold">$5 coffee gift card</span>. Limit 1 entry per person. Odds depend on
                        number of eligible entries. Full rules and entry details available upon request.
                      </p>
                    </div>
                  ) : (
                    <div className="lg:text-[2rem] text-[1rem] leading-[1.2]">
                      <p className="mb-6">
                        En fournissant votre nom, vous consentez à ce que Santé Canada et Proof Experiences utilise ces
                        renseignements pour communiquer avec vous par courriel si vous êtes la personne gagnante du
                        tirage d’un{' '}
                        <span className="font-bold">
                          prix consistant en une carte-cadeau de café de 5 $ (ou un prix équivalent)
                        </span>
                        .
                      </p>
                      <p className="mb-6">
                        Ces renseignements ne seront pas utilisés à des fins de sollicitation commerciale ou de
                        marketing et ne seront communiqués à aucun tiers.
                      </p>
                      <p className="mb-6">
                        Nous ne conserverons aucun renseignement personnel une fois le jeu terminé.
                      </p>
                      <p className="mb-6">
                        Aucun achat requis. Ouvert aux résidents du Canada ayant atteint l’âge de la majorité dans leur
                        province ou territoire de résidence. Le concours débute le{' '}
                        <span className="font-bold">20 septembre, 2026 à 9 h</span> et se termine le{' '}
                        <span className="font-bold">30 novembre, 2026 à 17 h</span>.{' '}
                        <span className="font-bold">50 PRIX</span> sont offerts chaque jour, chacun consistant en une{' '}
                        <span className="font-bold">carte-cadeau de café de 5 $</span>. Limite d’une participation par
                        personne. Les chances de gagner dépendent du nombre de participations admissibles reçues. Le
                        règlement complet et les détails de participation sont disponibles sur demande.
                      </p>
                    </div>
                  )}
                </section>

                <Button
                  onClick={() => {
                    closeModal();
                    setIsChecked(true);
                  }}
                >
                  {t('close')}
                </Button>
              </div>
            </div>,
            document.getElementById('master-layout'),
          )
        : null}
    </>
  );
};

export default Modal;
